import gql from 'graphql-tag';
import { eventListingAttributes } from './types/event';
import { userFollowAttributes } from './types/user-follow';

export const meQuery = gql`
  query MeQuery {
    me {
      id
      username
      email
    }
  }
`;

export const usersQuery = gql`
  query UsersQuery {
    users {
      id
      username
      displayName
      avatar {
        small {
          url
        }
      }
    }
  }
`;

export const userQuery = gql`
  query UserQuery($username: String!) {
    user(username: $username) {
      id
      discoverable
      displayName
      givenName
      familyName
      username
      about
      websiteUrl
      instagramUsername
      pronouns
      avatar {
        med {
          url
        }
        large {
          url
        }
      }
      primaryCity {
        id
        name
        slug
      }
      hostedEvents {
        ${eventListingAttributes}
      }
      hostedEventsCount
      pastHostedEventsCount
    }
  }
`;

export const userPastQuery = gql`
  query UserPastQuery($username: String!) {
    user(username: $username) {
      id
      discoverable
      displayName
      givenName
      familyName
      username
      pronouns
      primaryCity {
        id
        name
        slug
      }
      avatar {
        med {
          url
        }
        large {
          url
        }
      }
      pastHostedEvents {
        ${eventListingAttributes}
      }
      hostedEventsCount
      pastHostedEventsCount
    }
  }
`;

export const followUserMutation = gql`
  mutation FollowUserMutation($id: ID!) {
    followUser(id: $id) {
      ${userFollowAttributes}
    }
  }
`;

export const unfollowUserMutation = gql`
  mutation UnfollowUserMutation($id: ID!) {
    unfollowUser(id: $id) {
      ${userFollowAttributes}
    }
  }
`;

export const updateUserFollowMutation = gql`
  mutation UpdateUserFollowMutation($userId: ID!, $data: UserFollowInput!) {
    updateUserFollow(userId: $userId, data: $data) {
      ${userFollowAttributes}
    }
  }
`;

export const userSearchQuery = gql`
  query UserSearchQuery($query: String!) {
    userSearch(query: $query) {
      id
      username
      displayName
      avatar {
        small {
          url
        }
      }
    }
  }
`;
